import Vue from "vue";
import Router from "vue-router";
import AppHeaderWeb from "./layout/AppHeaderWeb";
import AppHeaderMobile from "./layout/AppHeaderMobile";
import AppFooter from "./layout/AppFooter";
import landingFooter from "./layout/landingFooter";
import Landing from "./views/Landing.vue";
import Airtime from "./views/Airtime.vue";
import Product from './views/Product/product'
import Fixing from "./views/Fixing.vue";
import Zesa from "./views/Zesa/zesa.ts";
import zesaCheckout from "./views/Zesa/zesaCheckOut";
import Checkout from "./views/CheckOut/CheckOut";
import Wallet from "./views/Wallet/Wallet";
import Replay from "./views/Replays/Replay";
import Callback from './views/Callback'
import ForgotPassword from './views/PasswordReset/ForgotPassword.ts'
import ForgotPasswordSuccess from './views/PasswordReset/forgotpasswordsuccess.ts'
import PasswordResetSuccess from './views/PasswordReset/passwordresetsuccess.ts'
import PasswordReset from './views/PasswordReset/passwordreset.ts'
import Credit from './views/Credits/Credit.ts'
import WalletTransactions from './views/WalletTransactions/WalletTransactions.ts'
import Privacy from './views/Privacy.vue'
import Products from './views/Products.vue'
import ProductDetail from './views/ProductDetail/productDetail'
import Terms from './views/Terms.vue'
import Login from './views/Login/login'
import Register from './views/Register.vue'
import Referral from "./views/Referral/referral";
import BankingDetails from "./views/BankingDetails/bankingdetails"
import Country from './views/Country/Country'
import { userAuth } from './services/security'
import { Plugins } from '@capacitor/core';

const { App } = Plugins;

import config from "@/settings/config.js"
import Contactus from "./views/ContactUs/contactus";
import Inbox from "./views/Inbox/inbox";
import City from "./views/City/City";
import ProductGrid from "./views/ProductGrid/productGrid";
import RecepientDetails from "./views/RecepientDetails/recepientDetails";
import GridCheckOut from "./views/GridCheckOut/GridCheckOut";
import ChangePassword from "./views/ChangePassword/changepassword";
import Team from "./views/team/team";
import BulkUpload from "./views/BulkUpload/bulkupload";
import BusTicket from "./views/Busticket/busticket";
import Passengers from "./views/Passengers/passengers";
import PaymentDetails from "./views/PaymentDetails/paymentdetails";
import ScodePayment from "./views/ScodePayment/scodepayment";
import FlexiPay from "./views/FlexiPay/FlexiPay";
import FlexiPayCheckOut from "./views/FlexiPayCheckOut/FlexiPayCheckOut"
import FlexiPayHistory from "./views/FlexiPayHistory/FlexiPayHistory"
import FlexiPayBalance from "./views/FlexiPayBalance/FlexiPayBalance"
import CustomerTransactions from "./views/Reports/CustomerTransactions/customertransactions"
import BulkUploadReport from "./views/BulkUploadReport/BulkUploadReport"
import CustomerOveralTransactions from "./views/Reports/CustomerOveralTransactions/customeroveraltransactions"
import ProductOveralSales from "./views/Reports/ProductOveralSales/productoveralsales"
import BulkTransactionsReport from "./views/BulkTransactionsReport/BulkTransactionsReport"

Vue.use(Router);

var header = AppHeaderWeb;
if (config.isMobile)
    header = AppHeaderMobile;

let router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [{
        path: '/',
        name: 'home',
        components: {
            header: header,
            default: Landing,
            footer: landingFooter
        },
    },
    {
        path: "/contactus",
        name: "contactus",
        components: {
            header: header,
            default: Contactus,
            footer: AppFooter
        }
    },
    {
        path: "/login",
        name: "login",
        components: {
            header: header,
            default: Login,
            footer: AppFooter
        }
    },
    {
        path: "/register",
        name: "register",
        components: {
            header: header,
            default: Register,
            footer: AppFooter
        }
    },
    {
        path: "/landing",
        name: "landing",
        components: {
            header: header,
            default: Landing,
            footer: landingFooter
        },
    },
    {
        path: "/fixing",
        name: "fixing",
        components: {
            default: Fixing,
        },
    },
    {
        path: "/zesa",
        name: "zesa",
        components: {
            header: header,
            default: Zesa,
            footer: AppFooter
        },
    },
    {
        path: "/products",
        name: "products",
        components: {
            header: header,
            default: Products,
            footer: AppFooter
        },
    },
    {
        path: "/product",
        name: "product",
        components: {
            header: header,
            default: Product,
            footer: AppFooter
        },
    },
    {
        path: "/productGrid",
        name: "productGrid",
        components: {
            header: header,
            default: ProductGrid,
            footer: AppFooter
        },
    },
    {
        path: "/gridcheckout",
        name: "gridcheckout",
        components: {
            header: header,
            default: GridCheckOut,
            footer: AppFooter
        },
    },
    {
        path: "/recepientDetails",
        name: "recepientDetails",
        components: {
            header: header,
            default: RecepientDetails,
            footer: AppFooter
        },
    },
    {
        path: "/Airtime",
        name: "Airtime",
        components: {
            header: header,
            default: Airtime,
            footer: AppFooter
        }
    }, {
        path: "/Terms",
        name: "Terms",
        components: {
            header: header,
            default: Terms,
            footer: AppFooter
        }
    },
    {
        path: "/Privacy",
        name: "Privacy.vue",
        components: {
            header: header,
            default: Privacy,
            footer: AppFooter
        }
    },
    {
        path: "/Checkout",
        name: "Checkout",
        components: {
            header: header,
            default: Checkout,
            footer: AppFooter
        },
        meta: {
            requiresAuth: true
        },
    },
    {
        path: "/zesaCheckout",
        name: "zesaCheckout",
        components: {
            header: header,
            default: zesaCheckout,
            footer: AppFooter
        },
        meta: {
            requiresAuth: true
        },
    },
    {
        path: '/callback',
        name: 'callback',
        components: {
            header: header,
            default: Callback
        }
    },
    {
        path: "/ForgotPassword",
        name: "ForgotPassword.ts",
        components: {
            header: header,
            default: ForgotPassword,
            footer: AppFooter
        }
    },
    {
        path: "/forgotpasswordsuccess",
        name: "forgotpasswordsuccess.ts",
        components: {
            header: header,
            default: ForgotPasswordSuccess,
            footer: AppFooter
        }
    },
    {
        path: "/passwordresetsuccess",
        name: "passwordresetsuccess.ts",
        components: {
            header: header,
            default: PasswordResetSuccess,
            footer: AppFooter
        }
    },
    {
        path: "/passwordreset",
        name: "passwordreset.ts",
        components: {
            header: header,
            default: PasswordReset,
            footer: AppFooter
        }
    },
    {
        path: "/credit",
        name: "Credit",
        components: {
            header: header,
            default: Credit,
            footer: AppFooter
        },
        meta: {
            requiresAuth: true
        },
    },
    {
        path: "/bulkuploadreport",
        name: "bulkuploadreport",
        components: {
            header: header,
            default: BulkUploadReport,
            footer: AppFooter
        },
        meta: {
            requiresAuth: true
        },
    },
    {
        path: "/bulktransactionsreport",
        name: "bulktransactionsreport",
        components: {
            header: header,
            default: BulkTransactionsReport,
            footer: AppFooter
        },
        meta: {
            requiresAuth: true
        },
    },
    {
        path: "/customeroveraltransactions",
        name: "customeroveraltransactions",
        components: {
            header: header,
            default: CustomerOveralTransactions,
            footer: AppFooter
        },
        meta: {
            requiresAuth: true
        },
    },
    {
        path: "/productoveralsales",
        name: "productoveralsales",
        components: {
            header: header,
            default: ProductOveralSales,
            footer: AppFooter
        },
        meta: {
            requiresAuth: true
        },
    },
    {
        path: "/customertransactions",
        name: "customertransactions",
        components: {
            header: header,
            default: CustomerTransactions,
            footer: AppFooter
        },
        meta: {
            requiresAuth: true
        },
    },
    {
        path: "/wallet",
        name: "Wallet",
        components: {
            header: header,
            default: Wallet,
            footer: AppFooter
        },
        meta: {
            requiresAuth: true
        },
    },
    {
        path: "/inbox",
        name: "inbox",
        components: {
            header: header,
            default: Inbox,
            footer: AppFooter
        },
        meta: {
            requiresAuth: true
        },
    },
    {
        path: "/replay",
        name: "Replay",
        components: {
            header: header,
            default: Replay,
            footer: AppFooter
        },
        meta: {
            requiresAuth: true
        },
    },
    {
        path: "/walletTransactions",
        name: "WalletTransactions",
        components: {
            header: header,
            default: WalletTransactions,
            footer: AppFooter
        },
        meta: {
            requiresAuth: true
        },
    },
    {
        path: "/productDetail",
        name: "ProductDetail",
        components: {
            header: header,
            default: ProductDetail,
            footer: AppFooter
        },
        meta: {
            requiresAuth: true
        },
    },
    {
        path: "/country",
        name: "Country",
        components: {
            header: header,
            default: Country,
            footer: AppFooter
        },
    },
    {
        path: "/city",
        name: "City",
        components: {
            header: header,
            default: City,
            footer: AppFooter
        },
    },
    {
        path: "/referral",
        name: "Referral",
        components: {
            header: header,
            default: Referral,
            footer: AppFooter
        },
        meta: {
            requiresAuth: true
        },
    },
    {
        path: "/team",
        name: "Team",
        components: {
            header: header,
            default: Team,
            footer: AppFooter
        },
        meta: {
            requiresAuth: true
        },
    },
    {
        path: "/bankingdetails",
        name: "BankingDetails",
        components: {
            header: header,
            default: BankingDetails,
            footer: AppFooter
        },
        meta: {
            requiresAuth: true
        },
    },
    {
        path: "/changepassword",
        name: "ChangePassword",
        components: {
            header: header,
            default: ChangePassword,
            footer: AppFooter
        },
        meta: {
            requiresAuth: true
        },
    },
    {
        path: "/bulkupload",
        name: "bulkupload",
        components: {
            header: header,
            default: BulkUpload,
            footer: AppFooter
        },
        meta: {
            requiresAuth: true
        },
    },
    {
        path: "/busticket",
        name: "busticket",
        components: {
            header: header,
            default: BusTicket,
            footer: AppFooter
        },
        meta: {
            requiresAuth: true
        },
    },
    {
        path: "/passenger",
        name: "passenger",
        components: {
            header: header,
            default: Passengers,
            footer: AppFooter
        },
        meta: {
            requiresAuth: true
        },
    },
    {
        path: "/paymentdetails",
        name: "paymentdetails",
        components: {
            header: header,
            default: PaymentDetails,
            footer: AppFooter
        },
        meta: {
            requiresAuth: true
        },
    },
    {
        path: "/scodepayment",
        name: "scodepayment",
        components: {
            header: header,
            default: ScodePayment,
            footer: AppFooter
        },
        meta: {
            requiresAuth: true
        },
    },
    {
        path: "/flexipay",
        name: "flexipay",
        components: {
            header: header,
            default: FlexiPay,
            footer: AppFooter
        },
        meta: {
            requiresAuth: true
        },
    },
    {
        path: "/flexipaycheckout",
        name: "flexipaycheckout",
        components: {
            header: header,
            default: FlexiPayCheckOut,
            footer: AppFooter
        },
        meta: {
            requiresAuth: true
        },
    },
    {
        path: "/flexipayhistory",
        name: "flexipayhistory",
        components: {
            header: header,
            default: FlexiPayHistory,
            footer: AppFooter
        },
        meta: {
            requiresAuth: true
        },
    },
    {
        path: "/flexipaybalance",
        name: "flexipaybalance",
        components: {
            header: header,
            default: FlexiPayBalance,
            footer: AppFooter
        },
        meta: {
            requiresAuth: true
        },
    }
    ]
})

export default router;

App.addListener('appUrlOpen', function (data) {
    const slug = data.url.split('/').pop();
    router.push({
        path: '/' + slug,
    });
});

router.beforeEach(async (to, from, next) => {
    let app = userAuth.data().user || { isAuthenticated: false }
    if (app.isAuthenticated) {
        if(userAuth.CheckIfRerral()!=null && to.path.toLowerCase() !='/changepassword')
            router.push('/changepassword');
        else    
        next()
        //else

    } else if (to.matched.some(record => record.meta.requiresAuth)) {
        userAuth.authenticate(to.path).then(() => {
            next();
        });
    } else {
        //No auth required. We can navigate
        next()
    }
});